module.exports = __webpack_public_path__ + "img/img-1.a9ae0666.jpg";